<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>{{ title }}</h1>
      <v-card :class="classPadding">
        <v-row>
          <v-col cols="12" md="12" sm="12" xs="12" :class="classPadding">
            <v-alert
              border="top"
              color="red lighten-2"
              dark
              dismissible
              v-model="showError"
            >
              <v-row v-for="(err, key) in errors" :key="key">
                <v-col :class="classPadding">
                  <span>• {{ err }}</span>
                </v-col>
              </v-row>
            </v-alert>
          </v-col>
        </v-row>
        <v-card-title>
          <span class="caption">Option to import</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" class="pa-0 ma-0">
              <v-checkbox
                label="Check/Clear All"
                :class="classPadding"
                v-model="checkAll"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="3" class="pa-0 ma-0">
              <v-checkbox
                label="1. Master File"
                :class="classPadding"
                v-model="masterfile"
              ></v-checkbox>
              <v-checkbox
                label="2. Employment Info"
                :class="classPadding"
                v-model="empInfo"
              ></v-checkbox>
              <v-checkbox
                label="3. Basic Salary"
                :class="classPadding"
                v-model="basicSal"
              ></v-checkbox>
              <v-checkbox
                label="4. Allowances"
                :class="classPadding"
                v-model="allo"
              ></v-checkbox>
              <v-checkbox
                label="5. Earnings"
                :class="classPadding"
                v-model="earnings"
              ></v-checkbox>
              <v-checkbox
                label="6. Annual Physical Exam"
                :class="classPadding"
                v-model="physicalExam"
              ></v-checkbox>
              <v-checkbox
                label="7. Bank Information"
                :class="classPadding"
                v-model="bankInfo"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="3" class="pa-0 ma-0">
              <v-checkbox
                label="8. Educational Background"
                :class="classPadding"
                v-model="eduBack"
              ></v-checkbox>
              <v-checkbox
                label="9. Family Information"
                :class="classPadding"
                v-model="familyInfo"
              ></v-checkbox>
              <v-checkbox
                label="10. Health Record"
                :class="classPadding"
                v-model="healthRecord"
              ></v-checkbox>
              <v-checkbox
                label="11. License and Other Eligibilities"
                :class="classPadding"
                v-model="license"
              ></v-checkbox>
              <v-checkbox
                label="12. Awards and Commendations"
                :class="classPadding"
                v-model="awardsComm"
              ></v-checkbox>
              <v-checkbox
                label="13. Disciplinary Cases"
                :class="classPadding"
                v-model="discCase"
              ></v-checkbox>
              <v-checkbox
                label="14. Medical Cases"
                :class="classPadding"
                v-model="medCase"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="3" class="pa-0 ma-0">
              <v-checkbox
                label="15. Previous Employment"
                :class="classPadding"
                v-model="prevEmp"
              ></v-checkbox>
              <v-checkbox
                label="16. Seminars and Trainings"
                :class="classPadding"
                v-model="sem"
              ></v-checkbox>
              <v-checkbox
                label="17. Seminars and Trainings Recommendation"
                :class="classPadding"
                v-model="semRecomm"
              ></v-checkbox>
              <v-checkbox
                label="18. Medical Reimbursement"
                :class="classPadding"
                v-model="medical"
              ></v-checkbox>

              <v-checkbox
                label="19. Health Insurance"
                :class="classPadding"
                v-model="healthIns"
              ></v-checkbox>

              <v-checkbox
                label="20. Disciplinary Remarks"
                :class="classPadding"
                v-model="discRemarks"
              ></v-checkbox>

              <v-checkbox
                label="21. Form Submitted to Government"
                :class="classPadding"
                v-model="govForms"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="3" class="pa-0 ma-0">
              <v-checkbox
                label="22. Government Exam"
                :class="classPadding"
                v-model="govExam"
              ></v-checkbox>

              <v-checkbox
                label="23. Language and Dialect"
                :class="classPadding"
                v-model="lang"
              ></v-checkbox>

              <v-checkbox
                label="24. Memo Received"
                :class="classPadding"
                v-model="memoReceived"
              ></v-checkbox>

              <v-checkbox
                label="25. Referral"
                :class="classPadding"
                v-model="referral"
              ></v-checkbox>

              <v-checkbox
                label="26. Reference"
                :class="classPadding"
                v-model="reference"
              ></v-checkbox>

              <v-checkbox
                label="27. Overseas Placement"
                :class="classPadding"
                v-model="overseas"
              ></v-checkbox>

              <v-checkbox
                label="28. Specialization"
                :class="classPadding"
                v-model="specialization"
              ></v-checkbox>

              <v-checkbox
                label="29. Benefit"
                :class="classPadding"
                v-model="benefit"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="6">
          <v-file-input
            label="Import file"
            :class="classPadding"
            v-model="file"
          ></v-file-input>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4">
          <v-btn outlined :loading="isUploading" @click.prevent="upload"
            >Upload</v-btn
          >&nbsp;
          <v-btn
            color="success"
            outlined
            :loading="isSaving"
            @click.prevent="save"
            :disabled="hasError"
            v-if="userAccess.submit >= 1"
            >Save</v-btn
          >
        </v-col>
      </v-row>

      <v-card>
        <v-tabs dark show-arrows background-color="primary" v-model="tab">
          <v-tabs-slider></v-tabs-slider>

          <v-tab v-for="item in items" :key="item.tab">
            <span class="caption">{{ item.tab }}</span>
          </v-tab>
          <v-tabs-items v-model="tab">
            <!-- <v-tab-item v-for="item in items" :key="item.tab">
              <v-card flat>
                <v-card-text>{{ item.content }}</v-card-text>
              </v-card>
            </v-tab-item>-->
            <v-tab-item>
              <v-card flat>
                <masterfile
                  :items="masterfileList"
                  :properties="properties"
                ></masterfile>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <employment-info
                  :items="empInfoList"
                  :properties="properties"
                ></employment-info>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <annual-physical-exam
                  :items="annualPEList"
                  :properties="properties"
                ></annual-physical-exam>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <bank-information
                  :items="bankInfoList"
                  :properties="properties"
                ></bank-information>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <educ-background
                  :items="educBackList"
                  :properties="properties"
                ></educ-background>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <family-information
                  :items="familyInfoList"
                  :properties="properties"
                ></family-information>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <health-record
                  :items="healthRecordList"
                  :properties="properties"
                ></health-record>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <license
                  :items="licenseList"
                  :properties="properties"
                ></license>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <basic-salary
                  :items="basicSalList"
                  :properties="properties"
                ></basic-salary>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <allowance
                  :items="allowanceList"
                  :properties="properties"
                ></allowance>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <earnings
                  :items="earningList"
                  :properties="properties"
                ></earnings>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <awards :items="awardsList" :properties="properties"></awards>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <disciplinary-cases
                  :items="discCaseList"
                  :properties="properties"
                ></disciplinary-cases>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <medical-cases
                  :items="medCaseList"
                  :properties="properties"
                ></medical-cases>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <previous-employment
                  :items="prevEmpList"
                  :properties="properties"
                ></previous-employment>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <seminars
                  :items="semTrainList"
                  :properties="properties"
                ></seminars>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <seminars-recomm
                  :items="semRecommList"
                  :properties="properties"
                ></seminars-recomm>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <medical
                  :items="medicalList"
                  :properties="properties"
                ></medical>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <health-ins
                  :items="healthInsList"
                  :properties="properties"
                ></health-ins>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <disciplinary-remarks
                  :items="discRemarksList"
                  :properties="properties"
                ></disciplinary-remarks>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <form-submitted
                  :items="govFormsList"
                  :properties="properties"
                ></form-submitted>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <gov-exam
                  :items="govExamList"
                  :properties="properties"
                ></gov-exam>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <language :items="langList" :properties="properties"></language>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <memo-received
                  :items="memoReceivedList"
                  :properties="properties"
                ></memo-received>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <referral
                  :items="referralList"
                  :properties="properties"
                ></referral>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <reference
                  :items="referenceList"
                  :properties="properties"
                ></reference>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <overseas-placement
                  :items="overseasList"
                  :properties="properties"
                ></overseas-placement>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <specialization
                  :items="specList"
                  :properties="properties"
                ></specialization>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <benefit
                  :items="benefitList"
                  :properties="properties"
                ></benefit>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
      <span class="caption" :class="classPadding">
        Click [
        <a @click="downloadFile">here</a>] to download the format.
      </span>
    </v-container>
  </div>
</template>
<script>
const Masterfile = () => import("./Masterfile");
const EmploymentInfo = () => import("./EmploymentInfo");
const AnnualPhysicalExam = () => import("./AnnualPhysicalExam");
const BankInformation = () => import("./BankInformation");
const EducBackground = () => import("./EducBackground");
const FamilyInformation = () => import("./FamilyInformation");
const HealthRecord = () => import("./HealthRecord");
const License = () => import("./License");
const BasicSalary = () => import("./BasicSalary");
const Allowance = () => import("./Allowance");
const Earnings = () => import("./Earnings");
const Awards = () => import("./Awards");
const DisciplinaryCases = () => import("./DisciplinaryCases");
const MedicalCases = () => import("./MedicalCases");
const PreviousEmployment = () => import("./PreviousEmployment");
const Seminars = () => import("./Seminars");
const SeminarsRecomm = () => import("./SeminarsRecomm");
const Medical = () => import("./Medical");
const HealthIns = () => import("./HealthIns");
const DisciplinaryRemarks = () => import("./DisciplinaryRemarks.vue");
const FormSubmitted = () => import("./FormSubmitted.vue");
const GovExam = () => import("./GovExam.vue");
const Language = () => import("./Language.vue");
const MemoReceived = () => import("./MemoReceived.vue");
const Referral = () => import("./Referral.vue");
const Reference = () => import("./Reference.vue");
const OverseasPlacement = () => import("./OverseasPlacement.vue");
const Specialization = () => import("./Specialization.vue");
const Benefit = () => import("./Benefit.vue");
import { isNullOrUndefined } from "../../../validation/validation.js";
import userAccessMixin from "../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/importMasterfile";
export default {
  metaInfo: {
    title: "Import Employee Masterfile",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
  },
  mixins: [userAccessMixin],
  components: {
    Masterfile,
    EmploymentInfo,
    AnnualPhysicalExam,
    BankInformation,
    EducBackground,
    FamilyInformation,
    HealthRecord,
    License,
    BasicSalary,
    Allowance,
    Earnings,
    Awards,
    DisciplinaryCases,
    MedicalCases,
    PreviousEmployment,
    Seminars,
    SeminarsRecomm,
    Medical,
    HealthIns,
    DisciplinaryRemarks,
    FormSubmitted,
    GovExam,
    Language,
    MemoReceived,
    Referral,
    Reference,
    OverseasPlacement,
    Specialization,
    Benefit,
  },
  data: () => ({
    title: "Import Employee Masterfile",
    classPadding: "my-0 py-0",
    isUploading: false,
    isSaving: false,
    tab: null,
    items: [
      { tab: "Master File", content: "Tab 1 Content" },
      { tab: "Employment Info", content: "Tab 2 Content" },
      { tab: "Annual Physical Exam", content: "Tab 3 Content" },
      { tab: "Bank Information", content: "Tab 4 Content" },
      { tab: "Educational Background", content: "Tab 5 Content" },
      { tab: "Family Information", content: "Tab 6 Content" },
      { tab: "Health Record", content: "Tab 7 Content" },
      { tab: "License and Other Eligibities", content: "Tab 8 Content" },
      { tab: "Basic Salary", content: "Tab 9 Content" },
      { tab: "Allowances", content: "Tab 10 Content" },
      { tab: "Earnings", content: "Tab 10 Content" },
      { tab: "Awards and Commendations", content: "Tab 10 Content" },
      { tab: "Disciplinary Cases", content: "Tab 10 Content" },
      { tab: "Medical Cases", content: "Tab 10 Content" },
      { tab: "Previous Employment", content: "Tab 10 Content" },
      { tab: "Seminars and Training", content: "Tab 10 Content" },
      {
        tab: "Seminars and Training Recommendation",
        content: "Tab 10 Content",
      },
      { tab: "Medical Reimbursements", content: "Tab 10 Content" },
      { tab: "Health Insurance", content: "Tab 10 Content" },
      { tab: "Displinary Remarks", content: "Tab 10 Content" },
      { tab: "Form Submitted to Government", content: "Tab 10 Content" },
      { tab: "Government Exam", content: "Tab 10 Content" },
      { tab: "Language and Dialect", content: "Tab 10 Content" },
      { tab: "Memo Received", content: "Tab 10 Content" },
      { tab: "Referral", content: "Tab 10 Content" },
      { tab: "Reference", content: "Tab 10 Content" },
      { tab: "Overseas Placement", content: "Tab 10 Content" },
      { tab: "Specialization", content: "Tab 10 Content" },
      { tab: "Benefit", content: "Tab 10 Content" },
    ],
    checkAll: false,
    masterfile: false,
    empInfo: false,
    bankInfo: false,
    eduBack: false,
    familyInfo: false,
    healthRecord: false,
    license: false,
    basicSal: false,
    allo: false,
    earnings: false,
    awardsComm: false,
    discCase: false,
    medCase: false,
    prevEmp: false,
    sem: false,
    semRecomm: false,
    medical: false,
    healthIns: false,
    physicalExam: false,
    discRemarks: false,
    govForms: false,
    govExam: false,
    lang: false,
    memoReceived: false,
    referral: false,
    reference: false,
    overseas: false,
    specialization: false,
    benefit: false,
    file: null,
    errors: [],
    showError: false,
    masterfileList: [],
    empInfoList: [],
    annualPEList: [],
    bankInfoList: [],
    educBackList: [],
    familyInfoList: [],
    healthRecordList: [],
    licenseList: [],
    basicSalList: [],
    allowanceList: [],
    earningList: [],
    awardsList: [],
    discCaseList: [],
    medCaseList: [],
    prevEmpList: [],
    semTrainList: [],
    semRecommList: [],
    medicalList: [],
    healthInsList: [],
    discRemarksList: [],
    govFormsList: [],
    govExamList: [],
    langList: [],
    memoReceivedList: [],
    referralList: [],
    referenceList: [],
    overseasList: [],
    specList: [],
    benefitList: [],
    uploadedItems: null,
    properties: [],
  }),
  computed: {
    hasError() {
      if (this.file === null && this.errors.length <= 0) return true;
      else if (
        !this.masterfile &&
        (this.basicSal ||
          this.allo ||
          this.earnings ||
          this.physicalExam ||
          this.bankInfo ||
          this.eduBack ||
          this.familyInfo ||
          this.healthRecord ||
          this.license ||
          this.awardsComm ||
          this.discCase ||
          this.medCase ||
          this.prevEmp ||
          this.sem ||
          this.semRecomm ||
          this.medical ||
          this.healthIns ||
          this.discRemarks ||
          this.govForms ||
          this.govExam ||
          this.lang ||
          this.memoReceived ||
          this.referral ||
          this.reference ||
          this.overseas ||
          this.specialization ||
          this.benefit)
      ) {
        if (this.errors.length > 0) {
          return true;
        } else {
          if (
            !isNullOrUndefined(this.file) &&
            (this.basicSalList.length > 0 ||
              this.allowanceList.length > 0 ||
              this.earningList.length > 0 ||
              this.annualPEList.length > 0 ||
              this.bankInfoList.length > 0 ||
              this.educBackList.length > 0 ||
              this.familyInfoList.length > 0 ||
              this.healthRecordList.length > 0 ||
              this.licenseList.length > 0 ||
              this.awardsList.length > 0 ||
              this.medCaseList.length > 0 ||
              this.discCaseList.length > 0 ||
              this.prevEmpList.length > 0 ||
              this.semTrainList.length > 0 ||
              this.semRecommList.length > 0 ||
              this.medicalList.length > 0 ||
              this.healthInsList.length > 0 ||
              this.discRemarksList.length > 0 ||
              this.govFormsList.length > 0 ||
              this.govExamList.length > 0 ||
              this.langList.length > 0 ||
              this.memoReceivedList.length > 0 ||
              this.referralList.length > 0 ||
              this.referenceList.length > 0 ||
              this.overseasList.length > 0 ||
              this.specList.length > 0 ||
              this.benefitList.length > 0)
          ) {
            return false;
          } else {
            return true;
          }
        }
      }

      // if (!this.masterfile && this.basicSal && (this.allo || this.earnings)) {
      //   if (this.errors.length > 0) {
      //     return true;
      //   } else {
      //     if (this.file !== null && this.basicSal.length > 0) {
      //       return true;
      //     } else {
      //       return false;
      //     }
      //   }
      // }

      if (!(this.masterfileList.length > 0)) return true;

      return this.errors.length > 0 ? true : false;
    },
    // basicAlloEarn() {
    //   if (this.file !== null && this.errors.length > 0) {
    //   }
    // },
    countSelected() {
      let i = 0;
      if (this.masterfile) i++;
      if (this.empInfo) i++;
      if (this.bankInfo) i++;
      if (this.eduBack) i++;
      if (this.familyInfo) i++;
      if (this.healthRecord) i++;
      if (this.license) i++;
      if (this.basicSal) i++;
      if (this.allo) i++;
      if (this.earnings) i++;
      if (this.awardsComm) i++;
      if (this.discCase) i++;
      if (this.medCase) i++;
      if (this.prevEmp) i++;
      if (this.sem) i++;
      if (this.semRecomm) i++;
      if (this.medical) i++;
      if (this.physicalExam) i++;
      if (this.healthIns) i++;
      if (this.discRemarks) i++;
      if (this.govForms) i++;
      if (this.govExam) i++;
      if (this.lang) i++;
      if (this.memoReceived) i++;
      if (this.referral) i++;
      if (this.reference) i++;
      if (this.overseas) i++;
      if (this.specialization) i++;
      if (this.benefit) i++;
      return i;
    },
  },
  methods: {
    upload() {
      this.isUploading = true;
      var formData = new FormData();
      var data = {
        masterfile: this.masterfile,
        empInfo: this.empInfo,
        bankInfo: this.bankInfo,
        eduBack: this.eduBack,
        familyInfo: this.familyInfo,
        healthRecord: this.healthRecord,
        license: this.license,
        basicSal: this.basicSal,
        allo: this.allo,
        earnings: this.earnings,
        awardsComm: this.awardsComm,
        discCase: this.discCase,
        medCase: this.medCase,
        prevEmp: this.prevEmp,
        sem: this.sem,
        semRecomm: this.semRecomm,
        medical: this.medical,
        healthIns: this.healthIns,
        physicalExam: this.physicalExam,
        discRemarks: this.discRemarks,
        govForms: this.govForms,
        govExam: this.govExam,
        language: this.lang,
        memoReceived: this.memoReceived,
        referral: this.referral,
        reference: this.reference,
        overseas: this.overseas,
        specialization: this.specialization,
        benefit: this.benefit,
      };
      formData.append("json", JSON.stringify(data));
      formData.append("file", this.file);

      this.$axios({
        method: "POST",
        url: `${API_ENDPOINT}/upload`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      })
        .then(({ data }) => {
          if (data.errors.length > 0) {
            this.errors = data.errors;
            this.properties = data.properties;
          } else {
            this.errors = [];
            this.properties = [];
          }
          this.uploadedItems = data;

          this.masterfileList = data.masterfile;

          this.empInfoList = data.employmentInfo;
          this.annualPEList = data.annualPE;
          this.bankInfoList = data.bankInfo;
          this.educBackList = data.educBack;
          this.familyInfoList = data.familyInfo;
          this.healthRecordList = data.healthRecord;
          this.licenseList = data.license;
          this.basicSalList = data.basicSalary;
          this.allowanceList = data.allowances;
          this.earningList = data.earnings;
          this.awardsList = data.awards;
          this.discCaseList = data.discCases;
          this.medCaseList = data.medCases;
          this.prevEmpList = data.prevEmp;
          this.semTrainList = data.semTraining;
          this.semRecommList = data.semRecomm;
          this.medicalList = data.medReim;
          this.healthInsList = data.healthIns;
          this.discRemarksList = data.discRemarks;
          this.govFormsList = data.govForms;
          this.govExamList = data.govExam;
          this.langList = data.language;
          this.memoReceivedList = data.memoReceived;
          this.referralList = data.referral;
          this.referenceList = data.reference;
          this.overseasList = data.overseas;
          this.specList = data.specialization;
          this.benefitList = data.benefits;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUploading = false;
        });
    },
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}/save`, this.uploadedItems)
        .then(() => {
          this.$toast.success("Record Successfully Uploaded");
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    reset() {
      this.masterfile = false;
      this.empInfo = false;
      this.bankInfo = false;
      this.eduBack = false;
      this.familyInfo = false;
      this.healthRecord = false;
      this.license = false;
      this.basicSal = false;
      this.allo = false;
      this.earnings = false;
      this.awardsComm = false;
      this.discCase = false;
      this.medCase = false;
      this.prevEmp = false;
      this.sem = false;
      this.semRecomm = false;
      this.medical = false;
      this.healthIns = false;
      this.physicalExam = false;
      this.discRemarks = false;
      this.govForms = false;
      this.govExam = false;
      this.lang = false;
      this.memoReceived = false;
      this.referral = false;
      this.reference = false;
      this.overseas = false;
      this.specialization = false;
      this.benefit = false;

      (this.masterfileList = []),
        (this.empInfoList = []),
        (this.annualPEList = []),
        (this.bankInfoList = []),
        (this.educBackList = []),
        (this.familyInfoList = []),
        (this.healthRecordList = []),
        (this.licenseList = []),
        (this.basicSalList = []),
        (this.allowanceList = []),
        (this.earningList = []),
        (this.awardsList = []),
        (this.discCaseList = []),
        (this.medCaseList = []),
        (this.prevEmpList = []),
        (this.semTrainList = []),
        (this.semRecommList = []),
        (this.medicalList = []),
        (this.healthInsList = []),
        (this.discRemarksList = []),
        (this.govFormsList = []),
        (this.govExamList = []),
        (this.langList = []),
        (this.memoReceivedList = []),
        (this.referralList = []),
        (this.referenceList = []),
        (this.overseasList = []),
        (this.specList = []),
        (this.benefitList = []),
        (this.uploadedItems = null);
      this.file = null;
    },
    downloadFile() {
      var subPath = process.env.VUE_APP_PATH;

      // window.open(
      //   `${subPath.slice(0, -1)}/Files/downloads/Master File Format.xlsx`
      // );

      var nameOfTheCsv = "Master File Format.xlsx";
      this.$axios
        .get(`/Files/downloads/v82/Master File Format_20230801.xlsx`, {
          responseType: "blob",
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data])
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", nameOfTheCsv);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((err) => console.log(err));
    },
  },
  watch: {
    checkAll(val) {
      if (val) {
        this.masterfile = true;
        this.empInfo = true;
        this.bankInfo = true;
        this.eduBack = true;
        this.familyInfo = true;
        this.healthRecord = true;
        this.license = true;
        this.basicSal = true;
        this.allo = true;
        this.earnings = true;
        this.awardsComm = true;
        this.discCase = true;
        this.medCase = true;
        this.prevEmp = true;
        this.sem = true;
        this.semRecomm = true;
        this.medical = true;
        this.healthIns = true;
        this.physicalExam = true;
        this.discRemarks = true;
        this.govForms = true;
        this.govExam = true;
        this.lang = true;
        this.memoReceived = true;
        this.referral = true;
        this.reference = true;
        this.overseas = true;
        this.specialization = true;
        this.benefit = true;
      } else {
        if (this.countSelected < 29) {
          //this.checkAll == false;
        } else {
          this.masterfile = false;
          this.empInfo = false;
          this.bankInfo = false;
          this.eduBack = false;
          this.familyInfo = false;
          this.healthRecord = false;
          this.license = false;
          this.basicSal = false;
          this.allo = false;
          this.earnings = false;
          this.awardsComm = false;
          this.discCase = false;
          this.medCase = false;
          this.prevEmp = false;
          this.sem = false;
          this.semRecomm = false;
          this.medical = false;
          this.healthIns = false;
          this.physicalExam = false;
          this.discRemarks = false;
          this.govForms = false;
          this.govExam = false;
          this.lang = false;
          this.memoReceived = false;
          this.referral = false;
          this.reference = false;
          this.overseas = false;
          this.specialization = false;
          this.benefit = false;
        }
      }
    },
    errors(val) {
      if (val.length > 0) this.showError = true;
      else this.showError = false;
    },
    countSelected(val) {
      if (val < 29) {
        this.checkAll = false;
      } else {
        this.checkAll = true;
      }
    },
  },
  created() {
    this.getUserAccessRights("IUMASTER");
  },
};
</script>
